import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { LanguageService } from './language.service';

export const languageGuard: CanMatchFn = (_route, segments) =>
  inject(LanguageService).setCurrent(segments[0]?.path);
